import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'

import './loadingSpinner.scss'

const LoadingSpinner = ({ label, size }) => (
  <div className='loading-spinner'>
    <CircularProgress size={size} />
    {label && <small className='loading-spinner__label'>{label}</small>}
  </div>
)

LoadingSpinner.defaultProps = {
  size: 50,
}

LoadingSpinner.propTypes = {
  label: PropTypes.string,
  size: PropTypes.number,
}

export default LoadingSpinner
